<template>
    <section class="shop-by-category-wrap clearfix">
        <div class="container">
            <h4 class="section-title">{{ $trans('storefront::layout.shop_by_category') }}</h4>

            <div class="shop-by-category clearfix">
                <div class="inner" v-for="(category, index) in categories" :key="index">
                    <a
                        :href="category.url"
                        class="shop-by-category-image"
                    >
                        <img :src="category.logo.path" alt="category logo">
                    </a>

                    <h3 v-text="category.name" class="name"></h3>

                    <a :href="category.url" class="url">{{ $trans('storefront::layout.shop_now') }}</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['categories'],
    };
</script>
